import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12798cd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "arrow-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "svg-item",
  width: "7",
  height: "12",
  viewBox: "0 0 7 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = ["fill"]

import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IconArrowRightWrap',
  props: {
    fillColor: { default: '' },
    showArrow: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { fillColor: string, showArrow: boolean };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    (props.showArrow)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          _createElementVNode("path", {
            d: "M4.93938 6L1.00004 2.06066C0.835307 1.89592 0.752939 1.81355 0.714879 1.72167C0.664132 1.59915 0.664132 1.4615 0.714879 1.33898C0.752939 1.2471 0.835307 1.16473 1.00004 0.999996C1.16478 0.835261 1.24714 0.752894 1.33903 0.714833C1.46154 0.664086 1.5992 0.664086 1.72171 0.714833C1.8136 0.752894 1.89597 0.835261 2.0607 0.999996L6.53037 5.46967C6.82327 5.76256 6.82327 6.23743 6.53037 6.53033L2.0607 11C1.89597 11.1647 1.8136 11.2471 1.72171 11.2852C1.5992 11.3359 1.46154 11.3359 1.33903 11.2852C1.24714 11.2471 1.16478 11.1647 1.00004 11C0.835307 10.8353 0.75294 10.7529 0.714879 10.661C0.664132 10.5385 0.664132 10.4008 0.714879 10.2783C0.752939 10.1864 0.835307 10.1041 1.00004 9.93934L4.93938 6Z",
            fill: props.fillColor || '#00C378'
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})